/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';

export const Alert = styled.div`
  
  width: 100%;
  margin: 10px 0px;
  padding: 5px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 768px) {
    padding: 5px 15px;
  }
`;

export const TextAlert = styled.div`
  color: ${(props) => props.theme.colors.blue};
  font-size: 1rem;
`;

export const IconAlert = styled.span`
  color: #ead414
  margin-right: 10px;
  font-size: 1.5rem;
`;
